import * as v from 'valibot';
import { hex16Schema } from '../../util/valibot';
export const nodeDescriptorSchema = v.object({
    id: v.number(),
    allocate_addr: v.boolean(),
    backup_binding_table_cache: v.boolean(),
    backup_discovery_cache: v.boolean(),
    backup_trust_center: v.boolean(),
    can_be_coordinator: v.boolean(),
    complex_descriptor: v.boolean(),
    created: v.string(),
    device_type_full: v.boolean(),
    extended_active_endpoints_available: v.boolean(),
    extended_simple_descriptor_available: v.boolean(),
    frequency_band_2400: v.boolean(),
    frequency_band_868: v.boolean(),
    frequency_band_902: v.boolean(),
    logical_type: v.string(),
    manufacturer: hex16Schema,
    manufacturer_name: v.nullish(v.string()),
    maximum_buffer_size: v.number(),
    maximum_incoming_transfer_size: v.number(),
    maximum_outgoing_transfer_size: v.number(),
    network_manager: v.boolean(),
    power_source_mains: v.boolean(),
    primary_binding_table_cache: v.boolean(),
    primary_discovery_cache: v.boolean(),
    primary_trust_center: v.boolean(),
    reciever_on_when_idle: v.boolean(),
    security_capable: v.boolean(),
    stack_compliance_revision: v.number(),
    user_descriptor: v.boolean(),
});
export function getManufacturerName(node_descriptor) {
    if (node_descriptor) {
        if (node_descriptor.manufacturer_name) {
            return node_descriptor.manufacturer_name;
        }
        else if (node_descriptor.manufacturer) {
            return node_descriptor.manufacturer.toString(16);
        }
    }
    return null;
}
